import { render } from "./memberDateSeting.vue?vue&type=template&id=a5b12ca2"
import script from "./memberDateSeting.vue?vue&type=script&lang=js"
export * from "./memberDateSeting.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__